module.exports = __webpack_public_path__ + "img/vertical_4_5_9016.f740816d.png";